import { Skeleton } from "@mui/material";
import * as React from "react";

export function LoadingValue(): React.JSX.Element {


    return (<Skeleton variant="text" width={150} sx={{ fontSize: '1.5rem' }} />)

}


export function LoadingList(width: string, height: string): React.JSX.Element {
    return (<Skeleton variant="rectangular" width={width} height={ height} />)
}

export function LoadingRoundValue(width: string, height: string, borderRadius: string): React.JSX.Element {
    return (<Skeleton variant="rounded" width={width} height={height} sx={{ borderRadius: borderRadius }} />)
}
